import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import { postOrderShipmentUploadInvoiceApi } from "../../../../../api/order/OrdersApi";

export const usePostOrderShipmentUploadInvoice = () => {
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: File) => postOrderShipmentUploadInvoiceApi(data),
        onSuccess: (res: any) => {
            console.log("res", res);
            if (String(res?.code) === '0000') {
                handleModal({
                    isOpen: true,
                    title: "송장 가져오기",
                    contents: `${res?.result}건 수정되었습니다!`,
                    type: 'confirm',
                });    
                return;
            }
            
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            
        },
    });

    return {mutate};
};
